<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_v"></a> </p>
<p class="noindent"> </p>
<h2 class="h2"><a id="toc"></a>Contents</h2>
<p class="noindent"> </p>
<p class="toc-chapter">Introduction  <a class="nounder" href="#/OEBPS/html/9780230249226_05_int#int">1</a></p>
<p class="toc-chapter">1.  The Great Depression: Misunderstanding Deflation  <a class="nounder" href="#/OEBPS/html/9780230249226_06_chp01#chp01">13</a></p>
<p class="toc-chapter">2.  The Triumph of Keynesian Economics  <span class="nounder" href="#/OEBPS/html/9780230249226_07_chp02#chp02" title="Link target outside of Sample">41</span></p>
<p class="toc-chapter">3.  Inflation: The Downfall of Keynesian Economics  <span class="nounder" href="#/OEBPS/html/9780230249226_08_chp03#chp03" title="Link target outside of Sample">69</span></p>
<p class="toc-chapter">4.  The Conservative Counterrevolution  <span class="nounder" href="#/OEBPS/html/9780230249226_09_chp04#chp04" title="Link target outside of Sample">95</span></p>
<p class="toc-chapter">5.  The Rise and Fall of Supply-Side Economics  <span class="nounder" href="#/OEBPS/html/9780230249226_10_chp05#chp05" title="Link target outside of Sample">123</span></p>
<p class="toc-chapter">6.  Starving the Beast Didn't Work  <span class="nounder" href="#/OEBPS/html/9780230249226_11_chp06#chp06" title="Link target outside of Sample">143</span></p>
<p class="toc-chapter">7.  Dealing with Tomorrow’s Economic Crisis  <span class="nounder" href="#/OEBPS/html/9780230249226_12_chp07#chp07" title="Link target outside of Sample">165</span></p>
<p class="toc-chapter">Appendices <span class="nounder" href="#/OEBPS/html/9780230249226_13_app#app" title="Link target outside of Sample">191</span></p>
<p class="toc-chapter">List of Abbreviations <span class="nounder" href="#/OEBPS/html/9780230249226_14_abb#abb" title="Link target outside of Sample">199</span></p>
<p class="toc-chapter">Notes <span class="nounder" href="#/OEBPS/html/9780230249226_15_not#not" title="Link target outside of Sample">201</span></p>
<p class="toc-chapter">Index <span class="nounder" href="#/OEBPS/html/9780230249226_16_ind#ind" title="Link target outside of Sample">257</span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230249226_04_toc.vue?55949754